import { useState, useEffect } from "react";
import { FaWhatsapp, FaArrowUp } from "react-icons/fa"; // react-icons kullanıyoruz
import { motion, AnimatePresence } from "framer-motion";

export default function FloatingButtons() {
  const [showTopBtn, setShowTopBtn] = useState(false);

  // Scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/905372153407"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp ile iletişime geç"
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-transform transform hover:scale-110"
      >
        <FaWhatsapp className="w-6 h-6" />
      </a>

      {/* Scroll to Top Button */}
      <AnimatePresence>
        {showTopBtn && (
          <motion.button
            onClick={scrollToTop}
            initial={{ opacity: 0}}
            animate={{ opacity: 1}}
            exit={{ opacity: 0}}
            className="fixed bottom-20 mb-2 right-6 z-50 bg-pink-500 hover:bg-pink-700 text-white p-4 rounded-full shadow-lg transition-transform transform hover:scale-110"
          >
            <FaArrowUp className="w-6 h-6" />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}
